import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';

import {
  AuthService,
  AvlaRestClientService,
  OptionElementDTO,
} from 'base-angular-avla';
import { CountriesService, PersonService } from 'services-sc-component';
import {
  AvlaGenericComponent,
  I18nService,
  InfoMessageDTO,
  LoadInfoDTO,
  MessageService,
} from 'shared-angular-components-avla';
import { CountryService } from 'shared-angular-components-avla/country/country.service';

declare let window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [CountriesService, PersonService],
})
export class AppComponent extends AvlaGenericComponent implements OnInit {
  public isValidSession = true;
  private translationLoaded = false;

  public static URL_LOGIN = '/auth/login/';
  //public static URL_LOGIN: string = "/consulta-mark-list";

  public defaultRedirectUrl = '/home';

  @ViewChild('modalWelcome') modalWelcome: any;

  rememberMe: boolean;
  loadingStopServers = false;
  fin = 22;
  i = 1;

  constructor(
    protected avlaRestClient: AvlaRestClientService,
    protected messageService: MessageService,
    protected router: Router,
    protected authService: AuthService,
    private route: ActivatedRoute,
    private viewContainerRef: ViewContainerRef,
    protected i18n: I18nService,
    protected personService: PersonService,
    protected countryService: CountryService,
    protected countriesService: CountriesService
  ) {
    super(avlaRestClient, messageService, router, authService, i18n);
    //Configura el login para solicitar el organizationUnitName o no
    this.authService.askOrganizationUnitName = false;
    sessionStorage.setItem(
      'auth_token',
      this.avlaRestClient.getTokenJwtFromLocalStorage()
    );
    if (sessionStorage.getItem('auth_token')) {
      console.log('auth token');
    }
    this.window = window;
  }

  public ngOnInit() {
    this.i18n.subscribe(
      traducciones => {
        Promise.resolve().then(() => {
          this.translationLoaded = true;
        });
        console.log('Se cargaron las traducciones');
      },
      error => {
        console.log('No pudieron cargarse las traducciones');
      }
    );

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        Promise.resolve().then(() => {
          this.loadingPage.setLoading();
          console.log('NavigationStart');
        });
      }
      if (event instanceof NavigationEnd) {
        Promise.resolve().then(() => {
          this.loadingPage.setLoaded();
          console.log('NavigationEnd');
        });
      }
    });

    this.setAlwaysAllowedUrls();
    this.authService.messageAnnouncedRedirectAfterLogin$.subscribe(() => {
      if (!this.authService.redirectUrl) {
        this.authService.redirectUrl = this.defaultRedirectUrl;
      }
      Promise.resolve().then(() => {
        this.router.navigate([this.authService.redirectUrl]).catch(err => this.routeAccordingError(err));
      });
    });
    this.authService.messageAnnouncedLogoutSignal$.subscribe(() => {
      console.log('Se recibe evento de logout, redireccionando a login');
      Promise.resolve().then(() => {
        this.router.navigate([AppComponent.URL_LOGIN]).catch(err => this.routeAccordingError(err));
      });
    });
    this.authService.messageAnnouncedRedirectAccessForbidden$.subscribe(
      (code: number) => {
        if (this.avlaRestClient.tokenExist) {
          Promise.resolve().then(() => {
            this.router.navigate(['/errors/access-forbidden/' + code.toString()]).catch(err => this.routeAccordingError(err));
          });
        } else {
          Promise.resolve().then(() => {
            this.router.navigate([
              '/errorsLogout/access-forbidden/' + code.toString(),
            ]).catch(err => this.routeAccordingError(err));
          });
        }
      }
    );
    if (!this.authService.redirectUrl) {
      this.authService.redirectUrl = this.defaultRedirectUrl;
    }
    this.rememberMe =
      this.authService.rememberMe === null
        ? AuthService.DEFAULT_REMEMBER_ME
        : this.authService.rememberMe;
    if (this.avlaRestClient.tokenExist && this.rememberMe) {
      // Este if permite entrar igualmente al login a pesar que exista sesión previa, se desloguea primero
      if (this.authService.redirectUrl == AppComponent.URL_LOGIN) {
        this.authService.logout().subscribe(
          data => {
            this.authService.emmitSignalLogout();
          },
          err => {
            this.routeAccordingError(err);
          }
        );
      } else {
        setTimeout(() => {
          this.authService.emmitLoginStatus(true);
        }, 10);
        this.loadUserInfo(); // Hay otro subscribe dentro
        this.loadOptions(null);
      }
    } else {
      //this.authService.emmitLoginStatus(false);
      this.authService.emmitSignalLogout();
    }
  }

  public urlNow(url: string) {
    if (url.includes('auth/login')) {
      return true;
    }
    return false;
  }

  stopServers() {
    if (this.loadingStopServers) {
      this.personService
        .recordUserAction(
          'Intentó detener la acción de detener servidores',
          this.countriesService.countryCodeGlobal,
          null
        )
        .subscribe(
          data => {
            this.messageService.announcedMessage(
              new InfoMessageDTO(
                'info',
                'No es posible detener la acción, llamar a TI urgente',
                AvlaGenericComponent.TIME_NOTIFICATION * 10
              )
            );
          },
          error => {
            this.routeAccordingError(error);
          }
        );
      return;
    }

    this.loadingStopServers = true;
    setTimeout(() => {
      this.personService
        .recordUserAction(
          'Presiono boton de detener servidores',
          this.countriesService.countryCodeGlobal,
          null
        )
        .subscribe(
          data => {
            this.messageService.announcedMessage(
              new InfoMessageDTO(
                'warning',
                'Tienes 60 segundos para cancelar la acción ',
                AvlaGenericComponent.TIME_NOTIFICATION * 5
              )
            );
            this.repeatTimeout();
          },
          error => {
            this.routeAccordingError(error);
          }
        );
    }, 3000);
  }

  public title = 'app works!';
  public loadingPage: LoadInfoDTO = new LoadInfoDTO();

  public get basicDataLoaded() {
    //Poner acá todos los otros indicadores de cosas cargadas previas a la página
    //Usando && lógico
    return this.translationLoaded;
  }

  private setAlwaysAllowedUrls() {
    let optionAllowed: OptionElementDTO = new OptionElementDTO();
    optionAllowed.url = '/auth/login';
    this.authService.optsAlwaysAllowed.push(optionAllowed);

    optionAllowed = new OptionElementDTO();
    optionAllowed.url = '/errors/access-forbidden/*';
    this.authService.optsAlwaysAllowed.push(optionAllowed);

    optionAllowed = new OptionElementDTO();
    optionAllowed.url = '/errors/error404';
    this.authService.optsAlwaysAllowed.push(optionAllowed);

    optionAllowed = new OptionElementDTO();
    optionAllowed.url = '/errors/error500';
    this.authService.optsAlwaysAllowed.push(optionAllowed);
  }

  protected readonly window = window;

  repeatTimeout() {
    if (this.fin === this.i) {
      this.messageService.announcedMessage(
        new InfoMessageDTO(
          'success',
          'Servidor reiniciado correctamente',
          AvlaGenericComponent.TIME_NOTIFICATION
        )
      );
      this.loadingStopServers = false;
      this.i = 1;
      return;
    }
    setTimeout(() => {
      this.messageService.announcedMessage(
        new InfoMessageDTO(
          'danger',
          'No hay conexión con el servidor,  intento número: ' +
            this.i.toString(),
          AvlaGenericComponent.TIME_NOTIFICATION
        )
      );
      this.i = this.i + 1;
      this.repeatTimeout();
    }, 1000);
  }
}
